export const defaultOutputListName = "loop_outputs";
export const defaultOutputSchemaFieldName = "value";

export const INPUT_LIST = "__input_list__";
export const OUTPUT_LIST = "__output_list__";
export const LOOP = "__loop__";
export const TAKTILE_TYPE = "__taktile_type__";

export const INTERNAL_DATA_KEYS = [INPUT_LIST, OUTPUT_LIST, LOOP, TAKTILE_TYPE];
